module.exports = __webpack_public_path__ + "img/ico057.79822c05.svg";